export const getFirstWordInString = (sentence = ""): string => {
  return sentence.split(" ")[0];
};
